import { useMemo } from "react";

import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { FilteredOrganizationRules } from "@/Common/Utilities/FilteredOrganizationRules";

/**
 * If a user's title is valid provided the userLicenceOrganizationRule is active and is part of the filtered organization rules provided.
 * @param filteredOrganizationRules The valid licence organization rules allowed
 * @param userLicenseOrganizationRule The user's specific Licence organization rule
 * @returns If the user licence organization rule is valid.
 */
export const useTitleValidation = (
    filteredOrganizationRules: FilteredOrganizationRules,
    userLicenseOrganizationRule: LicenceOrganisationRule
): boolean => useMemo(
    () => filteredOrganizationRules.isOrganizationInAvailableOrganizationRules(userLicenseOrganizationRule)
        && userLicenseOrganizationRule.isActive,
    [filteredOrganizationRules, userLicenseOrganizationRule]
);
